import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { IS_DEBUG } from './browser';

export function Trace(message?: any, ...optionalParams: any[]) {
  IS_DEBUG && window.console?.log(message, ...optionalParams);
}

export function Warn(message?: any, ...optionalParams: any[]) {
  window.appInsights?.trackTrace({
    message: [message, ...optionalParams].join(' '),
    severityLevel: SeverityLevel.Warning,
  });
  window.console?.warn(message, ...optionalParams);
}
